// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KUNc","title":"Info_title__2hTXB","links":"Info_links__378Sz","link":"Info_link__uUr8r","logo":"Info_logo__1-5at"};